import { render, staticRenderFns } from "./TextDate.vue?vue&type=template&id=3c0af549&"
import script from "./TextDate.vue?vue&type=script&lang=js&"
export * from "./TextDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports